import { useQuery } from '@tanstack/react-query';
import { fetchPayment } from '@/lib/api';

export function usePayment(id: string) {
  return useQuery({
    queryKey: ['payments', id],
    queryFn: () => fetchPayment(id),
    enabled: !!id,
  });
}
